import { CommonConfig } from '../../../configs/config.common';
import * as T_T from 'cryface';
import { DataDelegate } from '../data.delegate';
import { HimuraInject } from 'himura';
import { AxiosPromise } from '../../../utils/axios.promise';

@HimuraInject.NamedService('ShowingsAgentAutoDelegate')
export class ShowingsAgentAutoDelegate extends DataDelegate {

    constructor() {
        super('ShowingsAgentAutoDelegate');
    }

    public async agentMatch(addrOrName: string) {
        const commonConfigs = new CommonConfig();
        const apiHost: string = commonConfigs.apiHost;
        const fetched = await AxiosPromise.get(`${apiHost}/partner/match/text?text=${addrOrName}`);
        if (T_T.simpleDetect(fetched) && fetched.errorCode === 200) {
            const data = fetched.data;
            this.Data = data;
            return 1;
        } else {
            return 0;
        }
    }
}
